﻿window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('../../../share/client/js/scrolltop');
require('../../../share/client/js/top');
require('../../../share/client/js/login');
require('../../../share/client/js/footer');

// $(window).scroll(function () {
//     // scrollTop是浏览器滚动条的top位置，
//     var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
//     var overheight = 90;
//
//     if (scrollTop < overheight) {
//         var top = overheight - scrollTop;
//         $('.left').css('top', top + 'px');
//     } else {
//         $('.left').css('top', '10px');
//     }
// });

// 获取服务器时间
window.getServerTime = function () {
    var ltime = 0;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/systime',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            ltime = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return ltime;
};

window.getPictures = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/picture' + '?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.getPicturesets = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/pictureset' + '?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.getLives = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/live' + '?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.getVideos = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/video?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.getAudios = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/audio?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

window.getVideoAds = function (id) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/video_ads?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

// 获取列表广告
window.getListAds = function (column, start, stop) {
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/ads-list?column=' + column + '&start=' + start + '&stop=' + stop,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (data) {
            console.log(data);
        }
    });
    return result;
};

// 等待GIF
window.showwait = function () {
    if ($('#wait').css('display') != 'block')
        $('#wait').show();
};

window.hidewait = function () {
    if ($('#wait').css('display') == 'block')
        $('#wait').hide();
};

window.followUser = function (id, bfollow) {
    if (!id)
        return;
    $.ajax({
        type: 'post',
        async: false,
        url: ROOT + '/user/followed?id=' + id + '&follow=' + bfollow,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
};

window.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
};

window.getColumnIndex = function (id) {
    var columns;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/columnindex?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return null;
            }
            var html = '<a href="/">首页</a>';
            for (var i = data.length - 1; i >= 0; i--) {
                var info = data[i];
                html += ' > <a href="' + ROOT + '/column/' + info.id + '">' + info.name + '</a>';
            }
            columns = html;
        },
        error: function (data) {
            console.log(data);
            return null;
        }
    });
    return columns;
};

window.getColumnList = function (id, page, size) {
    if (!id) {
        return;
    }
    if (page === undefined || page == '' || isNaN(parseInt(page))) {
        page = 1;
    }
    if (size === undefined || size == '' || isNaN(parseInt(size))) {
        size = 10;
    }
    var result = null;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/column-list?id=' + id + '&page=' + page + '&size=' + size,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            result = data;
        },
        error: function (error) {
            console.log(error);
        }
    });
    return result;
};

window.getColumnChildren = function (id) {
    var columns;
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/children_columns?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return null;
            }
            columns = data;
        },
        error: function (data) {
            console.log(data);
            return null;
        }
    });
    return columns;
};



//////////////////
// WEBPACK FOOTER
// ./cms/client/js/common.page.js
// module id = 1
// module chunks = 0